import { FORGET_PASSWORD_REQUEST, FORGET_PASSWORD_SUCCESS, FORGET_PASSWORD_ERROR } from "../actions/forget_password"

let initialState = {
    loading: false,
    data: null,
    error: null
}

const forget_password = (state = initialState, action) => {
    switch (action.type) {
        case FORGET_PASSWORD_REQUEST:
            return {
                ...state,
                loading: true
            }

        case FORGET_PASSWORD_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload
            }
        case FORGET_PASSWORD_ERROR:
            return {
                ...state,
                loading: false,
                data: action.payload
            }

        default:
            return state;
    }
}

export default forget_password